/* eslint-disable max-len */
export default {
  en: {
    profile: {
      title: 'Profile',
      subscribe: 'Subscribe',
      isSubscribed: 'Subscribed',
      followers: {
        title: 'Followers',
        counted: ['follower', 'followers', 'followers'],
        none: 'The user has no followers'
      },
      projects: {
        title: 'Projects',
        none: 'The user has no public projects',
        popular: {
          none: 'The user has no popular public projects'
        }
      },
      subscriptions: {
        title: 'Subscriptions',
        counted: ['subscription', 'subscriptions', 'subscriptions'],
        none: 'The user has no subscriptions'
      },
      favorites: {
        title: 'Favorites',
        counted: ['subscription', 'subscriptions', 'subscriptions'],
        none: 'The user has no starred projects'
      },
      readme: {
        title: 'README for your profile',
        none: 'The profile README was not found. Share information about yourself by creating'
      }
    }
  },
  ru: {
    profile: {
      title: 'Профиль',
      subscribe: 'Подписаться',
      isSubscribed: 'Вы подписаны',
      followers: {
        title: 'Подписаны',
        counted: ['подписчик', 'подписчика', 'подписчиков'],
        none: 'У пользователя нет подписчиков'
      },
      projects: {
        title: 'Проекты',
        none: 'У пользователя нет публичных проектов',
        popular: {
          none: 'У пользователя нет популярных публичных проектов'
        }
      },
      subscriptions: {
        title: 'Подписки',
        counted: ['подписка', 'подписки', 'подписок'],
        none: 'У пользователя нет подписок'
      },
      favorites: {
        title: 'Избранное',
        counted: ['подписка', 'подписки', 'подписок'],
        none: 'У пользователя нет проектов в избранном'
      },
      readme: {
        title: 'README для вашего профиля',
        none: 'README профиля не найден. Поделитесь информацией о себе, создав'
      }
    }
  }
};
